import axios from 'axios';

export default (apiToken) => {
  axios.defaults.headers.common.Authorization = `Bearer ${apiToken}`;
};
